import React from 'react';
interface Guide {
  label: string;
  url: string;
}

interface UsefulGuidesProps {
  title?: string;
  guides?: Guide[];
}

export const UsefulGuides: React.FC<UsefulGuidesProps> = ({ title = 'Useful Guides', guides }) => {
  if (!guides?.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <p className="tc-subheading my-0">{title}</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {guides.map((guide, index) => (
          <a
            key={index}
            href={guide.url}
            className="border-dark-100 text-dark-200 bg-neutral hover:border-primary hover:shadow-primary/10 active:bg-background-300 flex min-h-[50px] w-full items-center rounded-md border p-4 text-[16px] leading-normal font-bold transition-all hover:shadow-xl active:shadow-none"
          >
            {guide.label}
          </a>
        ))}
      </div>
    </div>
  );
};
